import React from 'react';

import { translate } from '~l10n/client';

import { UIButton } from '~shared/components/buttons';

export interface Props {
  // close this overlay
  onClose: (state: boolean) => void;
  // text shown in the confirmation button
  confirm: string;
  // describes the title
  description: string;
  // action to take if accepted
  action: () => void;
  // title to show
  title: string;
  isLoading: boolean;
}

/**
 * This is used to confirm an action inside of a dialog. It used to transform a dialog into a confirmation dialog.
 */
export function ConfirmTransform({
  onClose,
  action,
  confirm,
  title,
  description,
  isLoading,
}: Props) {
  return (
    <div className="text-center flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <h3 className="text-display font-display m-0 text-md leading-8 font-500 text-blue-900">
          {title}
        </h3>
        <div className="text-base leading-8">{description}</div>
      </div>
      <div className="flex flex-row flex-wrap justify-around items-center gap-8">
        <UIButton
          data-testid={'overlay-action-button'}
          key="cancel"
          isDisabled={isLoading}
          onClick={() => onClose(false)}
        >
          {translate('Cancel')}
        </UIButton>
        <UIButton
          key="primary"
          isDisabled={isLoading}
          appearance="primary"
          onClick={action}
        >
          {confirm}
        </UIButton>
      </div>
    </div>
  );
}
